import React from 'react'
import { VIEW_MODES } from '../constants'

export function ViewControls({ viewMode, onViewModeChange }) {
  return (
    <div className="view-controls">
      <span className="view-label">View as</span>
      <button 
        className={`view-toggle ${viewMode === VIEW_MODES.GRID ? '-active' : ''}`}
        onClick={() => onViewModeChange(VIEW_MODES.GRID)}
        aria-label="Grid view"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9H7V5H3V9ZM3 14H7V10H3V14ZM8 14H12V10H8V14ZM13 14H17V10H13V14ZM8 9H12V5H8V9ZM13 5V9H17V5H13ZM18 14H22V10H18V14ZM3 19H7V15H3V19ZM8 19H12V15H8V19ZM13 19H17V15H13V19ZM18 19H22V15H18V19ZM18 5V9H22V5H18Z" />
        </svg>
      </button>
      <button 
        className={`view-toggle ${viewMode === VIEW_MODES.MASONRY ? '-active' : ''}`}
        onClick={() => onViewModeChange(VIEW_MODES.MASONRY)}
        aria-label="Masonry view"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 19H9V12H3V19ZM10 19H22V12H10V19ZM3 5V11H22V5H3Z" />
        </svg>
      </button>
    </div>
  )
}

